import { render } from "./AddLinkFontFile.vue?vue&type=template&id=6830ae08"
import script from "./AddLinkFontFile.vue?vue&type=script&lang=js"
export * from "./AddLinkFontFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__